import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles

const QuillEditor = (props) => {

    const [value, setValue] = useState(props.value);

    // Configure Quill modules/formats
    const modules = {
        toolbar: [
        ],
    };

    const formats = [

    ];

    useEffect(() => {
        setValue(convertPlainTextToQuillFormat(props.value))
    }, [props.value])

    // Handle text change
    const handleChange = (content) => {
        setValue(content);
        const newVal = convertHtmlToPlainText(content)
        if (newVal !== props.value) {
            props.onChange(newVal)
        }
        // props.onChange(convertHtmlToPlainText(content))
    };

    // Custom style for the Quill editor to ensure it grows properly
    useEffect(() => {
        // Add custom CSS to make sure the editor grows properly
        const style = document.createElement('style');
        style.innerHTML = `
      .ql-editor {
        min-height: 200px;
        max-height: none;
        overflow-y: visible;
      }
    `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);
    const convertHtmlToPlainText = (html) => {
        if (!html) return '';
        
        // Create a temporary DOM element
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        // Replace <p>, <div> and <br> tags with newlines
        const content = tempDiv.innerHTML
          .replace(/<p[^>]*>/gi, '')
          .replace(/<\/p>/gi, '\n')
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/<div[^>]*>/gi, '')
          .replace(/<\/div>/gi, '\n');
        
        // Set the modified content back to get the text content
        tempDiv.innerHTML = content;
        
        // Get text content and trim extra whitespace
        let plainText = tempDiv.textContent || tempDiv.innerText || '';
        
        // Remove extra newlines (more than 2 consecutive)
        plainText = plainText.replace(/\n{3,}/g, '\n\n');
        
        return plainText.trim();
      };

    const convertPlainTextToQuillFormat = (text) => {
        // Replace newlines with line breaks that Quill understands
        return text.split('\n').map(line => {
            return { insert: line + '\n' };
        });
    };

    // Convert plain text to HTML with proper line breaks
    const convertPlainTextToHTML = (text) => {
        // Replace newlines with <br> tags
        return text.split('\n').join('<br>');
    };

    return (
        <div className="w-full max-w-4xl mx-auto p-4">
            <ReactQuill
                theme={null}
                value={value}
                onChange={handleChange}
                modules={modules}
                formats={formats}
                style={{
                    height: 'auto',
                    marginBottom: '40px' // Space for toolbar
                }}
            />
        </div>
    );
};

export default QuillEditor;